// Read-or-write classification for a Worker route, in its own module with no
// imports so Node's test runner can check it under --experimental-strip-types.
// useBackend.ts pulls in the Supabase client, which only resolves in a browser
// build, so the decision that matters cannot be tested from there.

/**
 * A route is a read if its handler is named getSomething, which is Retool's
 * convention and holds for all 61 read handlers.
 *
 * Misjudging in one direction is harmless: a read treated as a write costs one
 * unnecessary refresh. The other direction is not. A write treated as a read is
 * cached and deduplicated, so an operator clicking Approve twice inside the
 * cache window gets the first response back and believes the second click
 * landed when the server never saw it. Only `get*` is therefore trusted, and
 * web/test/liveRefresh.test.ts asserts that no handler named `get*` writes.
 */
export function isReadRoute(route: string): boolean {
  const name = route.split('/').pop() ?? route
  return /^get[A-Z]/.test(name)
}
